import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Col, Container, Row } from 'react-bootstrap'
import './Games.css'
import ticTacToeImage from '../../../assets/images/tic-tac-toe.png'
import thisOrThatImage from '../../../assets/images/this-or-that.png'
import emojiPlayImage from '../../../assets/images/emoji-play.png'
import { showToast } from '../../../Components/Toast/toast'
import { getIsUserSubscribedFromLogs, getUserSubscriptionLogs } from '../../../Services/User/UserSubscriptionService'
import { FaArrowLeftLong } from 'react-icons/fa6'
import heartDecor from '../../../assets/images/coin-store-figma/decor-heart.svg'

const Games = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const chat_id = searchParams.get('chat_id') ?? location.state?.chat_id ?? null
  const user_id = searchParams.get('user_id') ?? location.state?.user_id ?? null

  const games = [
    {
      id: 1,
      title: 'Tic Tac Toe',
      route: '/games/tic-tac-toe',
      image: ticTacToeImage,
    },
    {
      id: 2,
      title: 'This Or That',
      route: '/games/this-or-that',
      image: thisOrThatImage,
    },
    {
      id: 3,
      title: 'Emoji Play',
      route: '/games/emoji-play',
      image: emojiPlayImage,
    },
  ]

  const handleGameClick = async (route) => {
    try {
      const response = await getUserSubscriptionLogs()
      const isSubscribed = getIsUserSubscribedFromLogs(response)

      if (!isSubscribed) {
        showToast('Please upgrade your membership to play games', 'error')
        navigate('/subscription-plans')
        return
      }

      if (route === '/games/this-or-that') {
        const params = new URLSearchParams()
        if (chat_id != null) params.set('chat_id', String(chat_id))
        if (user_id != null) params.set('user_id', String(user_id))
        const query = params.toString()
        navigate(query ? `${route}?${query}` : route, {
          state: {
            chat_id,
            user_id,
          },
        })
        return
      }

      navigate(route)
    } catch (error) {
      console.error('Error checking subscription before opening game:', error)
      showToast('Unable to verify subscription. Please try again.', 'error')
    }
  }

  return (
    <section className="games-figma-page">
      <img src={heartDecor} alt="" className="games-figma-heart" aria-hidden="true" />
      <div className="games-figma-hero">
        <Container className="games-figma-hero-inner">
          <button className="games-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
            <FaArrowLeftLong />
          </button>
          <h1 className="games-figma-title">Games</h1>
        </Container>
      </div>

      <div className="games-figma-main py-sm-5 py-4">
        <Container className="games-figma-container">
          <Row className="g-4 justify-content-center">
            {games.map((game) => (
              <Col key={game.id} xs={12} sm={6} md={4} lg={4} className="games-figma-col d-flex">
                <div
                  className="game-card"
                  onClick={() => handleGameClick(game.route)}
                >
                  <div className="game-card-image">
                    <img src={game.image} alt={game.title} />
                  </div>
                  <div className="game-card-title">
                    <h5>{game.title}</h5>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </section>
  )
}

export default Games
